/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  fixDecoderSize,
  fixEncoderSize,
  getBytesDecoder,
  getBytesEncoder,
  getStructDecoder,
  getStructEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
  type ReadonlyUint8Array,
} from '@solana/kit';

/**
 * Arguments for migrate_entry instruction.
 * This is decoded from migrator_migrate_payload passed by initializer.
 */
export type MigrateEntryArgs = { entryId: ReadonlyUint8Array };

export type MigrateEntryArgsArgs = MigrateEntryArgs;

export function getMigrateEntryArgsEncoder(): FixedSizeEncoder<MigrateEntryArgsArgs> {
  return getStructEncoder([['entryId', fixEncoderSize(getBytesEncoder(), 32)]]);
}

export function getMigrateEntryArgsDecoder(): FixedSizeDecoder<MigrateEntryArgs> {
  return getStructDecoder([['entryId', fixDecoderSize(getBytesDecoder(), 32)]]);
}

export function getMigrateEntryArgsCodec(): FixedSizeCodec<
  MigrateEntryArgsArgs,
  MigrateEntryArgs
> {
  return combineCodec(
    getMigrateEntryArgsEncoder(),
    getMigrateEntryArgsDecoder(),
  );
}
